module.exports = __webpack_public_path__ + "img/48_28.ae553404.png";